import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";
import { ICateringSupplier } from "./CateringSupplierRepository";

export class GetCateringSupplierByIdEndpoint implements IGetCateringSupplierEndpoint
{
    public async execute(nodeId: number, supplierId: string): Promise<ICateringSupplier>
    {
        try
        {
            const response = await axios.get<ICateringSupplier>(apis.allApiv2 + nodeId + `/catering-supplier/` + supplierId);
            return response.data;
        }
        catch (error: any)
        {
            throw ApiError.fromAxiosResponse(error.response as AxiosResponse);
        }
    }
}

export interface IGetCateringSupplierEndpoint
{
    execute(nodeId: number, supplierId: string): Promise<ICateringSupplier>;
}
